export default __webpack_public_path__ + "static/media/21_0B2AuC-g-min.4aa1b528.jpg";